import {configureStore} from './store';
import {connect} from 'react-redux';
import {Component} from 'react';
import {Provider} from 'react-redux';
import React from 'react';
import {setEmployeeFromLocalStorage} from './current_user/actions';
import {Status} from './status/component.jsx';
import {useEffect} from 'react';

const store = configureStore();

export const App = ({children}) => {
  return (
    <Provider store={store}>
      {children}
      <Status />
    </Provider>
  );
};
